export default "__VITE_ASSET__7451b93f__"